import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = {
  fallback: ReactNode;
  children: ReactNode;
};

type State = {
  hasError: boolean;
  errorMessage: string;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, errorMessage: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: String(error) };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    // In development, show the raw error so it can be diagnosed without opening DevTools.
    if (import.meta.env.DEV) {
      return (
        <div role="alert" style={{ padding: '2rem', fontFamily: 'monospace', color: 'crimson', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
          <strong>DEV — render error caught by ErrorBoundary:</strong>
          {'\n\n'}
          {this.state.errorMessage}
          {'\n\n'}
          <button type="button" onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.fallback;
  }
}
